"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _spinner = _interopRequireDefault(require("../../spinner/spinner.presenter"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var SpinnerContainer = function SpinnerContainer() {
  return _react.default.createElement("div", {
    className: "agillicSpinner"
  }, _react.default.createElement(_spinner.default, {
    size: 30,
    isThin: true,
    uniqueID: "spinner"
  }));
};
var _default = SpinnerContainer;
exports.default = _default;